/**
 * Paths where the training-alerts nudge must never appear.
 */

const NUDGE_BLOCKED_PREFIXES: readonly string[] = [
  '/alerts',
  '/for-officers',
  '/for-professionals',
  '/write-for-apt',
  '/secondary-employment/for-employers',
  '/employer-signup',
  '/professional-signup',
  '/login',
  '/signin',
  '/signup',
  '/register',
  '/auth',
  '/checkout',
  '/tac-shop/checkout',
  '/tac-shop/order',
  '/payment-success',
  '/express-register',
  '/dashboard',
  '/backoffice',
  '/admin',
  '/k9',
  '/k9-ops',
  '/provider-signup',
] as const;

function normalizePathname(pathname: string): string {
  if (!pathname) {
    return '/';
  }
  const q = pathname.indexOf('?');
  const h = pathname.indexOf('#');
  let end = pathname.length;
  if (q >= 0) {
    end = Math.min(end, q);
  }
  if (h >= 0) {
    end = Math.min(end, h);
  }
  const path = pathname.slice(0, end) || '/';
  return path.startsWith('/') ? path : `/${path}`;
}

/** True when pathname is auth, checkout, alerts, or other blocked surfaces. */
export function isTrainingAlertsNudgePathBlocked(pathname: string): boolean {
  const path = normalizePathname(pathname);
  return NUDGE_BLOCKED_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
